import { LinePath } from '@visx/shape';

import { BrushPreviewGroupProps } from './brush-preview.model';

const LinePreview = <T extends {}>({ groupKey, group, xAccessor, yScale, data, xScale }: BrushPreviewGroupProps<T>) => {
    return (
        <>
            {group.series.map((series: any) => {
                const uniqId = `${groupKey}-${series.column}-line`;
                return (
                    <LinePath
                        id={uniqId}
                        key={uniqId}
                        data={data}
                        x={d => xScale(xAccessor(d)) || 0}
                        y={(d: any) => {
                            const yValue = d[series.column];
                            return yScale(yValue);
                        }}
                        stroke={series.color}
                        strokeWidth={0.75}
                        opacity={0.65}
                    />
                );
            })}
        </>
    );
};

export { LinePreview };
